import React, { SetStateAction } from "react"
import { Select as FiltrableSelect } from "components/Shared/Select"
import { options } from "../../constants"
import "./index.scss"
import withVisibility from "../../../../../../Shared/Hocs/withVisibility"

interface SelectProps {
	metric: string
	label: string
	value: string
	setValue: React.Dispatch<SetStateAction<string>>
}

const Select: React.FC<SelectProps> = ({ metric, label, value, setValue }) => {
	return (
		<div className="select-benchmark-timeline">
			<FiltrableSelect
				id="select-metric"
				className="select-metric-benchmark"
				options={options().filter(
					(option) => option.isVisible && option.code != metric
				)}
				label={label}
				value={value}
				onChange={(option) => setValue(option.code)}
			/>
		</div>
	)
}

export default withVisibility(Select)
